import { initReactI18next } from "react-i18next";
import i18n from "i18next";

const resources = {
  en: {
    translation: {
      cs: "CareerSuite",
      career: "CAREER",
      suite: "SUITE",
      pltQuote: "Elevate Your Professional Journey",
      pltQuote1: "Professional",
      pltQuote2: "Journey",
      Quote:
        " Connect with opportunities, showcase your skills, and take the next step in your career with CareerSuite's comprehensive platform.",
      login: "Login",
      loginQ: "Already have an account?",
      termS: "I agree to CareerSuite's Terms of Service and Privacy Policy",
      ch: "Changed password",
      submit: "Submit",
      verifyEmail: "Verify Your Email",
      otpV:"OTP-Verification",
      oneTimePass:"Enter your one-time password.",
      NotReceive:"Didn't receive code?",
      cancel: "Cancel",
      next: "Next",
      back: "Back",
      verify: "Verify",
      signup: "Signup",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
